import React, { useState } from 'react';
import './css/menu.css';

const VEHICLES = {
  Autos: [
    {
      name: 'GRAND i10 HATCHBACK',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1038.png',
      customLink: 'https://my.matterport.com/show/?m=4GZduYTM3qG',
      external: true,
    },
    {
      name: 'GRAND i10 SEDAN',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1001.png',
      customLink: 'https://my.matterport.com/show/?m=bM5bvVKY9bz',
      external: true,
    },
    {
      name: 'ACCENT',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1036.png',
      customLink: 'https://my.matterport.com/show/?m=FnVKCkpreEx',
      external: true,
    },
  ],
  SUVs: [
    {
      name: 'CRETA',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1030.png',
      customLink: 'https://my.matterport.com/show/?m=zFtQbQ3Z8rx',
      external: true,
    },
    {
      name: 'KONA HYBRID',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1035.png',
      customLink: 'https://my.matterport.com/show/?m=gXksUcj91GA',
      external: true,
    },
    {
      name: 'TUCSON',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1031.png',
      customLink: 'https://my.matterport.com/show/?m=CjWvEZs9qAp',
      external: true,
    },
    /*{
      name: 'IONIQ 5',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1040.png',
      customLink: 'https://my.matterport.com/show/?m=nDpCwmmYVYt',
      external: true,
    },*/
    {
      name: 'SANTA FE',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1023.png',
      customLink: 'https://my.matterport.com/show/?m=Szi8YWWecju',
      external: true,
    },
    {
      name: 'PALISADE',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1034.png',
      customLink: 'https://my.matterport.com/show/?m=7HtsqF2sRtE',
      external: true,
    },
  ],
  Van: [
    {
      name: 'STARIA',
      img: 'https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1037.png',
      customLink: 'https://my.matterport.com/show/?m=YW2yPtEjhfL',
      external: true,
    },
  ],
};

const TABS = ['Autos', 'SUVs', 'Van'];

const ShowroomDropdown = () => {
  const [activeTab, setActiveTab] = useState('Autos');

  return (
    <div className="showroom-dropdown-menu">
      <div className="showroom-tabs">
        {TABS.map(tab => (
          <button
            key={tab}
            className={`showroom-tab${activeTab === tab ? ' active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="showroom-vehicles">
        {VEHICLES[activeTab].map((vehicle, idx) => (
          vehicle.customLink ? (
            <a
              href={vehicle.customLink}
              className="showroom-vehicle-card"
              key={vehicle.name}
              target={vehicle.external ? "_blank" : undefined}
              rel={vehicle.external ? "noopener noreferrer" : undefined}
            >
              <img src={vehicle.img} alt={vehicle.name} className="showroom-vehicle-img" />
              <div className="showroom-vehicle-name">{vehicle.name}</div>
            </a>
          ) : (
            <div className="showroom-vehicle-card" key={vehicle.name}>
              <img src={vehicle.img} alt={vehicle.name} className="showroom-vehicle-img" />
              <div className="showroom-vehicle-name">{vehicle.name}</div>
            </div>
          )
        ))}
      </div>
    </div>
  );
};

export default ShowroomDropdown; 